import React, { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useProfile } from '../../../context/ProfileProvider/useProfile';
import { Stack } from "@fluentui/react/lib/Stack";
import WorkSpaceAdmListComp from "./WorkSpaceAdmListComp";
import styles from "../../Style/List.module.css";
import { useTranslation } from "react-i18next";

const TemporalityMenu  = (props: any) => {
  const [reload, setReload] = useState<boolean>(false);
  const [isAdminOrganization, setisAdminOrganization] = useState<boolean>(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const { t, i18n } = useTranslation();
  const profile = useProfile();
  
  let search = searchParams.get("search");

  const { nameOrg } = useParams();

  useEffect(() => {
    if(reload == true ){
      setReload(false)
    }
  }, [reload]);

  useEffect(() => {
    if(profile.organizations != undefined)
    {
      for(let organization of profile.organizations)
      {
        if(nameOrg == organization.internalName)
        {
          if(organization.isAdmin == true)
          {
            
            setisAdminOrganization(true);
          }
          else{
            setisAdminOrganization(false);
          }
        }
      }
    }
  }, [profile]);

  return (
    <div>
      <Stack horizontal className={styles.hPage} style={{display:"block"}}>   
        <Stack.Item grow>
          <h3 className={styles.hList}>{t("Temporality.message")}</h3>
        </Stack.Item>     
        <Stack.Item className={styles.InputSearch} style={{display:"flex"}}>
          <div style={{flex: 1, display:"flex", alignItems:"end", height:"56px"}}>
            {t("Temporality.descriptionTemporalityMenu")}
          </div>
        </Stack.Item>
      </Stack>
     
      {reload?(<div></div>):(
          nameOrg != undefined?(
            <WorkSpaceAdmListComp
              nameOrg={nameOrg}
              name={search? search : ""}
              hiddenContexMenu={isAdminOrganization == false}
            />
          ):(<li className={styles.itemContent}></li>))}
    </div>
  );
};


export default TemporalityMenu;
